import { render, staticRenderFns } from "./HomeHeroCopyAuthor.vue?vue&type=template&id=0f313e04&scoped=true&"
import script from "./HomeHeroCopyAuthor.vue?vue&type=script&lang=js&"
export * from "./HomeHeroCopyAuthor.vue?vue&type=script&lang=js&"
import style0 from "./HomeHeroCopyAuthor.vue?vue&type=style&index=0&id=0f313e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f313e04",
  null
  
)

export default component.exports